.exampleBox {
    margin-right: 15px;
    p {
        margin-bottom: 0px;
        margin-top: 5px;
    }
}
.boldTip {
    font-weight: 700;
}
.example {
    display: flex;
    align-items: center;
}
